// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"227":"c3e9ce05","596":"3c9818e6"}[chunkId] + ".js";
};